import { render, staticRenderFns } from "./VuesticSliderColorPicker.vue?vue&type=template&id=4566be22"
import script from "./VuesticSliderColorPicker.vue?vue&type=script&lang=js"
export * from "./VuesticSliderColorPicker.vue?vue&type=script&lang=js"
import style0 from "./VuesticSliderColorPicker.vue?vue&type=style&index=0&id=4566be22&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports